/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PopupPicker from "vux/src/components/popup-picker/index.vue";
export default {
  name: 'SinglePicker',
  components: {
    PopupPicker: PopupPicker
  },
  props: {
    value: {
      require: true
    },
    title: String,
    data: Array,
    columns: {
      type: Number,
      default: 1
    },
    format: {
      type: [Function, Boolean],
      default: function _default(v) {
        return {
          name: v.name,
          value: String(v.id)
        };
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    show: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isTransferDom: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    copyValue: {
      get: function get() {
        return this.value ? [this.value] : [];
      },
      set: function set(v) {
        this.$emit('input', v[0]);
      }
    }
  }
};